<template>
  <a-table
    :columns="columns"
    :row-key="(record) => record.objId"
    :data-source="data"
    :pagination="pagination"
    :loading="loading"
    @change="handleTableChange"
  >
    <template slot="isDeal" slot-scope="record">
      <span>{{ record === true ? "已处理" : "未处理" }}</span>
    </template>
    <template slot="operate" slot-scope="text, operate">
      <a
        v-on:click.prevent="
          topage(`/home/feedback/feedbackDetails?objId=${operate.objId}`)
        "
        >详情信息</a
      >

      <a href="javascript:;" @click="del(operate)">删除</a>
    </template>
  </a-table>
</template>
<script>
import { userList, userListDel, userListSeach } from "@/api/homeApi.js";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    sorter: true,
    scopedSlots: { customRender: "objId" },
  },
  {
    title: "用户手机号",
    dataIndex: "userPhone",
  },
  {
    title: "用户名称",
    dataIndex: "userName",
  },
  {
    title: "反馈内容",
    dataIndex: "feedbackContent",
    sorter: true,
    scopedSlots: { customRender: "feedbackContent" },
  },
  {
    title: "处理状态",
    dataIndex: "isDeal",
    sorter: true,
    scopedSlots: { customRender: "isDeal" },
  },
  {
    title: "回馈内容",
    dataIndex: "dealContent",
    sorter: true,
    scopedSlots: { customRender: "dealContent" },
  },
  {
    title: "提交时间",
    dataIndex: "createTime",
    sorter: true,
    scopedSlots: { customRender: "createTime" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    sorter: true,
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      loading: false,
      columns,
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        name: "",
        region: undefined,
      },
    };
  },
  mounted() {
    this.getUserList();
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    // 分页数据
    getUserList() {
      userList(10, 1).then((res) => {
        this.data = res.data;
        console.log(res);
      });
    },
    // 删除
    del(row) {
      console.log(row);
      this.loading = true;
      userListDel(row.objId).then((res) => {
        message.success("删除成功");
        this.getUserList();
        this.loading = false;
      });
    },
    // 搜索
    query() {
      this.loading = true;
      userListSeach(
        10,
        1,
        this.formInline.userPhone,
        this.formInline.isDeal
      ).then((res) => {
        this.loading = false;
        this.data = res.data;
      });
    },
    // 分页按钮
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      userList(10, this.pagination.current).then((res) => {
        this.data = res.data;
        console.log(res);
        this.loading = false;
      });
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    //
  },
};
</script>


// WEBPACK FOOTER //
// src/views/systemManagement/feedback/feedbackContent.vue